var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { ActivatedRoute, Router } from '@angular/router';
import { InfluencerService } from '../../services/influencer/influencer.service';
import { ContactPermissionStatus } from '../../../models/influencer';
import { Location } from '@angular/common';
import { PlaceholderVisibilityService } from '../../services/placeholder-visibility/placeholder-visibility.service';
import { CommonConstant, InfluencerTabName, InfluencerTab, CampaignInfluencerStatus } from '../../app.constants';
import { UserService } from '../../services/user.service';
import { GroupService } from '../../services/group-details/group.service';
import { AchooPopupComponent } from '../../core/achoo-popup/achoo-popup.component';
import { ModalService } from '../../services/modal/modal.service';
import { CampaignService } from '../../services/campaign/campaign.service';
import { AddInfluencersCampaign } from '../../../models/campaign/add-influencers-campaign';
import { TranslateService } from '@ngx-translate/core';
import { InfluencerGroupsService } from '../influencer-groups/influencer-groups.service';
import { InfluencerCampaignActivity } from '../../../models/influencer-campaign';
import { PdfViewerService } from '../pdf-viewer/pdf-viewer.service';
import { Title } from '@angular/platform-browser';
import { PdfExportService } from '../../services/export-pdf/pdf-export.service';
import { AbstractAchooComponent } from '../abstract-achoo.component';
import { EventTrackerService, Page, UserActionType, ActivePages, TargetType, ActionSource, ActionDetails } from '../../services/event-tracker/event-tracker.service';
import { InvalidAction } from '../../../models/user';
import { CacheService } from '../../services/cache/cache.service';
import { CommunicationService } from '../../services/communication/communication.service';
import { AppSettings } from '../../utils/app-settings';
import { InfluencerCampaignActivityComponent } from './influencer-campaign-activity/influencer-campaign-activity.component';
import { DemographicComponent } from './demographic/demographic.component';
import { MoveInfluencerFromGroupComponent } from '../group-details/move-influencer-from-group/move-influencer-from-group.component';
import { HttpErrorResponse } from '@angular/common/http';
var InfluencerCampaignParam;
(function (InfluencerCampaignParam) {
    InfluencerCampaignParam["removedCampaign"] = "0";
})(InfluencerCampaignParam || (InfluencerCampaignParam = {}));
var InfluencerComponent = /** @class */ (function (_super) {
    __extends(InfluencerComponent, _super);
    function InfluencerComponent(route, router, influencerService, location, placeholderService, userService, groupService, campaignService, influencerGroupService, modalService, eventTracker, pdfViewerService, translateService, pdfService, cacheService, communicationService, title) {
        var _this = _super.call(this, userService) || this;
        _this.route = route;
        _this.router = router;
        _this.influencerService = influencerService;
        _this.location = location;
        _this.placeholderService = placeholderService;
        _this.userService = userService;
        _this.groupService = groupService;
        _this.campaignService = campaignService;
        _this.influencerGroupService = influencerGroupService;
        _this.modalService = modalService;
        _this.eventTracker = eventTracker;
        _this.pdfViewerService = pdfViewerService;
        _this.translateService = translateService;
        _this.pdfService = pdfService;
        _this.cacheService = cacheService;
        _this.communicationService = communicationService;
        _this.title = title;
        _this.selectedCampaign = new AddInfluencersCampaign();
        _this.selectedInfluencerCampaign = new InfluencerCampaignActivity;
        _this.showActivityLog = true;
        _this.hiddenBackButton = false;
        return _this;
    }
    InfluencerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params.subscribe(function (res) {
            _this.influencerId = res.id;
        });
        _super.prototype.ngOnInit.call(this);
        this.route.queryParams.subscribe(function (params) {
            _this.groupId = params.group_id && Number(params.group_id);
            // check hidden back button
            _this.hiddenBackButton = params.hideBackButton;
            // keep target page
            _this.target = params.target;
            // get campaign influencer details if tab is campaign
            if (params.campaignInfluencerId) {
                _this.campaignInfluencerId = params.campaignInfluencerId;
            }
        });
        this.route.data.subscribe(function (res) {
            _this.activeTabIndex = res.order;
        });
        this.route.queryParams.subscribe(function (params) {
            _this.fromPath = params.from_path;
            _this.selectedCampaignId = Number(params.selectedCampaign);
        });
        // using cached data. Only fetch once time
        var influencerDetailsData = this.influencerService.influencerDetails;
        if (influencerDetailsData && influencerDetailsData.id === Number(this.influencerId)) {
            this.initializeInfluencerPage(influencerDetailsData);
        }
        else {
            // deleted cached data
            this.influencerService.clearCachedInfluencerData();
            if (!this.cacheService.has("influencer_" + this.influencerId)) {
                this.placeholderService.show(CommonConstant.INFLUENCER_BASIC_INFORMATION_HOLDER);
            }
            this.cacheService.get("influencer_" + this.influencerId, this.influencerService.getInfluencer(this.influencerId))
                .subscribe(function (data) {
                _this.initializeInfluencerPage(data);
                _this.placeholderService.hide(CommonConstant.INFLUENCER_BASIC_INFORMATION_HOLDER);
            });
        }
    };
    InfluencerComponent.prototype.checkCreditAvailability = function (influencerId, companyId) {
        this.influencerService.checkInfluencerCreditAvailability(influencerId, companyId);
    };
    InfluencerComponent.prototype.changeDemographicSource = function (channelId) {
        this.demographicChannelParam = channelId;
        this.insightChannelParam = channelId;
        this.updateUrl(InfluencerTabName.DEMOGRAPHIC);
    };
    InfluencerComponent.prototype.changeChannel = function (data) {
        this.insightChannelParam = data.channel;
        this.demographicChannelParam = data.channel;
        this.channelFollowerParam = data.channelFollower;
        this.updateUrl(data.activeTab);
    };
    InfluencerComponent.prototype.updateUrl = function (activeTab) {
        var params = {
            activeAccount: this.companyId,
        };
        if (this.groupId) {
            params = Object.assign({}, params, { group_id: this.groupId });
        }
        if (this.hiddenBackButton) {
            params = Object.assign({}, params, { hideBackButton: this.hiddenBackButton });
        }
        if (this.campaignInfluencerId) {
            params = Object.assign({}, params, { campaignInfluencerId: this.campaignInfluencerId });
        }
        if (this.fromPath) {
            params = Object.assign({}, params, { from_path: this.fromPath });
        }
        if (this.selectedCampaignId) {
            params = Object.assign({}, params, { selectedCampaign: this.selectedCampaignId });
        }
        if (this.target) {
            params = Object.assign({}, params, { target: this.target });
        }
        if (this.insightChannelParam) {
            params = Object.assign({}, params, { insightChannel: this.insightChannelParam });
        }
        if (this.channelFollowerParam) {
            params = Object.assign({}, params, { channelFollower: this.channelFollowerParam });
        }
        if (this.demographicChannelParam) {
            params = Object.assign({}, params, { demographicChannel: this.demographicChannelParam });
        }
        var url = this.router.createUrlTree(['influencer', this.influencerId, activeTab], { queryParams: params })
            .toString();
        this.location.go(url);
    };
    InfluencerComponent.prototype.initializeInfluencerPage = function (influencerData) {
        if (!influencerData) {
            return;
        }
        this.influencer = influencerData;
        // pre-load data by given channel from url
        this.updateActiveChannelFromUrl(this.influencer.channels);
        // update browser title
        this.title.setTitle(this.translateService.instant('INFLUENCER.TITLE', {
            influencerName: this.influencer.name
        }));
        this.showCountryFlagIcon = true;
        // segment track event view details group
        this.eventTracker.trackUserAction(UserActionType.VIEW, Page.INFLUENCER_DETAILS, {
            id: influencerData.id,
            name: influencerData.name,
            type: TargetType.INFLUENCER
        }, undefined, undefined, {
            type: ActivePages.INFLUENCER_DETAILS,
            name: this.influencer.name,
            id: influencerData.id
        });
    };
    InfluencerComponent.prototype.updateActiveChannelFromUrl = function (influencerChannels) {
        var _this = this;
        this.route.queryParams.subscribe(function (params) {
            if (params.insightChannel) {
                var selectedChannel = influencerChannels.find(function (c) { return c.id === Number(params.insightChannel); });
                if (selectedChannel && AppSettings.getActivePlatformList().indexOf(selectedChannel.platformName.toLowerCase()) >= 0) {
                    _this.influencerService.updateActiveChannel(selectedChannel);
                }
            }
        });
    };
    InfluencerComponent.prototype.loadInfluencerCommunication = function (influencerId, companyId) {
        var _this = this;
        this.communicationService.fetchInfluencerConversation(companyId, influencerId).subscribe(function (res) {
            _this.influencerConversation = res;
        }, function (error) {
            if (error instanceof HttpErrorResponse && error.status === 404) {
                _this.influencerConversation = {
                    id: 0,
                    createdAt: null,
                    lastUpdated: null,
                    messages: [],
                    name: null,
                    participants: [],
                    status: 0 /* Normal */,
                    isHidden: false,
                    isJoined: true,
                    isSelected: false,
                    permission: ContactPermissionStatus.UNDEFINED
                };
            }
        });
    };
    InfluencerComponent.prototype.companyChangeCallback = function (companyId) {
        var _this = this;
        this.cacheService.get("group_list_" + companyId, this.influencerGroupService.getInfluencerGroupShortList(companyId))
            .subscribe(function (res) {
            _this.influencerGroupList = res.map(function (group) { return ({
                id: group.id,
                name: group.name
            }); });
        });
        // load list campaign
        this.cacheService.get("campaign_list_" + companyId, this.campaignService.getCampaignShortListForCompany(companyId))
            .subscribe(function (res) {
            _this.campaignList = res ? res.filter(function (campaignItem) { return campaignItem.status !== CampaignInfluencerStatus.ARCHIVED; }).map(function (campaign) { return ({
                id: campaign.id,
                name: campaign.name,
                brief: campaign.brief
            }); }) : [];
        });
        // load influencer communication
        this.loadInfluencerCommunication(this.influencerId, companyId);
        this.checkCreditAvailability(this.influencerId, this.companyId);
        if (this.influencerCampaignActivity) {
            this.influencerCampaignActivity.campaignInfluencerId = undefined;
            this.influencerCampaignActivity.initialize();
        }
    };
    InfluencerComponent.prototype.ngOnDestroy = function () {
        // update browser title
        this.title.setTitle(this.translateService.instant('APP.TITLE'));
        this.influencerService.updateActiveChannel(null);
    };
    InfluencerComponent.prototype.shouldShowActionButtonForCampaign = function () {
        if (!this.influencerCampaignActivity || !this.isActiveCampaignTab) {
            return false;
        }
        return this.influencerCampaignActivity.selectedCampaign && this.influencerCampaignActivity.selectedCampaign.campaignInfluencerId > 0;
    };
    InfluencerComponent.prototype.getActiveCampaignName = function () {
        if (!this.influencerCampaignActivity || !this.isActiveCampaignTab) {
            return null;
        }
        return this.influencerCampaignActivity.selectedCampaign.name;
    };
    InfluencerComponent.prototype.showOverview = function () {
        this.activeTabIndex = InfluencerTab.OVERVIEW;
        this.updateUrl(InfluencerTabName.OVERVIEW);
    };
    InfluencerComponent.prototype.showInsight = function () {
        this.activeTabIndex = InfluencerTab.INSIGHT;
        this.updateUrl(InfluencerTabName.INSIGHT);
    };
    InfluencerComponent.prototype.showDemographics = function () {
        this.activeTabIndex = InfluencerTab.DEMOGRAPHIC;
        this.updateUrl(InfluencerTabName.DEMOGRAPHIC);
    };
    InfluencerComponent.prototype.showActivity = function () {
        this.activeTabIndex = InfluencerTab.ACTIVITY;
        this.updateUrl(InfluencerTabName.ACTIVITY);
    };
    InfluencerComponent.prototype.showCampaign = function () {
        this.activeTabIndex = InfluencerTab.CAMPAIGN;
        this.updateUrl(InfluencerTabName.CAMPAIGN);
    };
    InfluencerComponent.prototype.getCurrentActiveChannel = function () {
        return this.influencerService.currentActiveChannel ? this.influencerService.currentActiveChannel.id : null;
    };
    InfluencerComponent.prototype.back = function () {
        if (this.fromPath && !this.selectedCampaignId) {
            this.cacheService.disableCacheRemoving(this.getCachingKeys(this.companyId, this.influencerId));
            return this.router.navigate([this.fromPath]);
        }
        if (this.fromPath && this.selectedCampaignId) {
            this.cacheService.disableCacheRemoving(this.getCachingKeys(this.companyId, this.influencerId, this.campaignInfluencerId));
            return this.router.navigate([this.fromPath], { queryParams: { selectedCampaign: this.selectedCampaignId } });
        }
        else if (this.groupId && this.groupId !== 0) {
            this.cacheService.disableCacheRemoving(this.getCachingKeys(this.companyId, this.influencerId));
            return this.router.navigate(['groups', this.groupId]);
        }
        else {
            this.cacheService.disableCacheRemoving();
            return this.location.back();
        }
    };
    InfluencerComponent.prototype.showAddToGroup = function () {
        this.activeBottomBar = true;
        this.isEnableAddToGroup = true;
    };
    InfluencerComponent.prototype.showAddToCampaign = function () {
        this.activeBottomBar = true;
        this.isEnableAddToCampaign = true;
    };
    InfluencerComponent.prototype.hideBottomBar = function (needToClearPendingData) {
        if (needToClearPendingData) {
            this.pendingAddInfluencerToGroup = null;
        }
        this.activeBottomBar = false;
        this.isEnableAddToGroup = false;
        this.isEnableAddToCampaign = false;
        this.showCreateNewGroupFragment = false;
    };
    InfluencerComponent.prototype.addCurrentInfluencerToGroup = function (moveInfluencerGroup) {
        if (!moveInfluencerGroup.influencer_group_id) {
            return;
        }
        moveInfluencerGroup.influencerList = [Number(this.influencerId)];
        this.hideBottomBar();
        this.pendingAddInfluencerToGroup = moveInfluencerGroup;
        if (moveInfluencerGroup.addForReview) {
            this.addInfluencerToGroupAsPending(moveInfluencerGroup);
        }
        else {
            this.addInfluencerToGroupAsNormal(moveInfluencerGroup);
        }
    };
    InfluencerComponent.prototype.addInfluencerToGroupAsNormal = function (influencerToAdd) {
        var _this = this;
        this.groupService.addInfluencerToGroup(influencerToAdd).subscribe(function (res) {
            _this.afterAddingInfluencerToGroupSuccess(influencerToAdd);
            _this.sendChamMixpanelEvent(false);
        }, function (err) {
            _this.showAddToGroup();
            if (err.error.data === 'invalid_level') {
                _this.userService.doInvalidActionByLevel('Add to Group', err.error.message);
                _this.sendInvalidActionToSegement(_this.influencerGroupService.extractLimitInfoFromErrorMessage(err.error.message, influencerToAdd.influencerList.length, _this.userService.maxGroupInfluencers, false), influencerToAdd, null);
            }
            else {
                _this.addInfluencerToGroupErrorPopupRef = _this.modalService.openInCenter(_this.addInfluencerToGroupErrorPopup);
            }
        });
    };
    InfluencerComponent.prototype.addInfluencerToGroupAsPending = function (influencerToAdd) {
        var _this = this;
        this.groupService.addInfluencerToGroupAsPending(influencerToAdd).subscribe(function (res) {
            _this.afterAddingInfluencerToGroupSuccess(influencerToAdd);
        }, function (err) {
            _this.showAddToGroup();
            _this.addInfluencerToGroupErrorPopupRef = _this.modalService.openInCenter(_this.addInfluencerToGroupErrorPopup);
        });
    };
    InfluencerComponent.prototype.afterAddingInfluencerToGroupSuccess = function (influencerToAdd) {
        this.showAlertSuccessAddInfluencerToGroup(influencerToAdd.addForReview);
        this.pendingAddInfluencerToGroup = null;
        // track event to Segment
        this.eventTracker.trackUserAction(UserActionType.ACTION, Page.GROUP, {
            id: influencerToAdd.influencer_group_id,
            name: influencerToAdd.influencerGroupName,
            type: TargetType.INFLUENCER_GROUP
        }, __assign({ action: UserActionType.UPDATE, source: ActionSource.BOTTOM_BAR, actionDetails: ActionDetails.ADDED_INFLUENCERS }, influencerToAdd), undefined, this.activePage);
    };
    InfluencerComponent.prototype.addInfluencerToCampaign = function (addInfluencerCampaign) {
        var _this = this;
        if (!addInfluencerCampaign.campaign_id) {
            return;
        }
        // prepare influencer data to webservice
        addInfluencerCampaign.influencers = [{
                influencer_id: Number(this.influencerId),
                action: CommonConstant.ADD_ACTION,
                status: addInfluencerCampaign.is_accepted ? CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name.toLowerCase() : ''
            }];
        this.campaignService.addInfluencerToCampaign(addInfluencerCampaign).subscribe(function (res) {
            _this.selectedCampaignNotificationMsg = addInfluencerCampaign.campaign_name;
            _this.showAlertSuccessAddInfluencerToCampaign();
            _this.hideBottomBar();
            // track event to Segment
            _this.eventTracker.trackUserAction(UserActionType.ACTION, Page.CAMPAIGN, {
                id: addInfluencerCampaign.campaign_id,
                name: addInfluencerCampaign.campaign_name,
                type: TargetType.CAMPAIGN
            }, __assign({ action: UserActionType.UPDATE, source: ActionSource.BOTTOM_BAR, actionDetails: ActionDetails.ADDED_INFLUENCERS }, addInfluencerCampaign), undefined, _this.activePage);
            if (!addInfluencerCampaign.is_accepted) {
                _this.sendChamMixpanelEvent(true);
            }
            _this.clearCachedCampaignInfluencersData(addInfluencerCampaign.campaign_id);
            _this.userService.triggerUpdateActivatedInfluencers();
        }, function (err) {
            if (err.error.data === 'invalid_level') {
                _this.userService.doInvalidActionByLevel('Add to Campaign', err.error.message);
                _this.sendInvalidActionToSegement(_this.influencerGroupService.extractLimitInfoFromErrorMessage(err.error.message, addInfluencerCampaign.influencers.length, _this.userService.maxCampaignInfluencers, true), null, addInfluencerCampaign);
            }
            if (err.error.data === 'archived_campaign') {
                _this.modalService.openInCenter(_this.addInfluencerToCampaignErrorPopup);
            }
        });
    };
    InfluencerComponent.prototype.sendChamMixpanelEvent = function (isAddedToCampaign) {
        if (isAddedToCampaign) {
            this.eventTracker.trackUserAction(UserActionType.CHAM_INVITED_CAMPAIGN_INFLUENCER);
        }
        else {
            this.eventTracker.trackUserAction(UserActionType.CHAM_ADD_INFLUENCER_TO_GROUP);
        }
    };
    InfluencerComponent.prototype.sendInvalidActionToSegement = function (limitInfo, influencerAddToGroup, influencerAddToCampaign) {
        var detailAction = new InvalidAction(true, limitInfo.blockedReason, limitInfo.wallType, limitInfo.wallName, true, limitInfo.maxValue, limitInfo.desiredValue, this.userService.accountLevelName);
        // send event when adding influencer to group
        if (influencerAddToGroup) {
            this.eventTracker.trackUserInvalidAction(detailAction, UserActionType.ACTION, Page.GROUP, {
                id: influencerAddToGroup.influencer_group_id,
                name: influencerAddToGroup.influencerGroupName,
                type: TargetType.INFLUENCER
            }, __assign({ action: UserActionType.UPDATE, source: ActionSource.BOTTOM_BAR, actionDetails: ActionDetails.ADDED_INFLUENCERS }, influencerAddToGroup), undefined, {
                type: ActivePages.INFLUENCER_DETAILS,
                name: this.influencer.name,
                id: this.influencer.id,
            });
        }
        // send event when adding to Campaign
        if (influencerAddToCampaign) {
            this.eventTracker.trackUserInvalidAction(detailAction, UserActionType.ACTION, Page.CAMPAIGN, {
                id: influencerAddToCampaign.campaign_id,
                name: influencerAddToCampaign.campaign_name,
                type: TargetType.CAMPAIGN
            }, __assign({ action: UserActionType.UPDATE, source: ActionSource.BOTTOM_BAR, actionDetails: ActionDetails.ADDED_INFLUENCERS }, influencerAddToCampaign), undefined, {
                type: ActivePages.INFLUENCER_DETAILS,
                name: this.influencer.name,
                id: this.influencer.id,
            });
        }
    };
    InfluencerComponent.prototype.closeErrorAddingInfluencerAlert = function () {
        if (this.addInfluencerToGroupErrorPopupRef) {
            this.modalService.closeSinglePopup(this.addInfluencerToGroupErrorPopupRef);
        }
    };
    InfluencerComponent.prototype.showAlertSuccessAddInfluencerToGroup = function (addForReview) {
        if (addForReview) {
            this.addInfluencerToGroupSuccessMessage = this.translateService.instant('group_details.influencer.add_influencer_as_pending');
        }
        else {
            this.addInfluencerToGroupSuccessMessage = this.translateService.instant('group_details.influencer.add_influencer_to_group');
        }
        this.modalService.open(this.alertAddInfluencerToGroupSuccess, undefined, true);
    };
    InfluencerComponent.prototype.showAlertSuccessAddInfluencerToCampaign = function () {
        this.modalService.open(this.alertAddInfluencerToCampaignSuccess, undefined, true);
    };
    InfluencerComponent.prototype.hideAlertSuccess = function () {
        this.modalService.close();
    };
    InfluencerComponent.prototype.openCreateNewGroupFragment = function (evt) {
        this.pendingAddInfluencerToGroup = evt;
        this.isEnableAddToGroup = false;
        this.showCreateNewGroupFragment = true;
    };
    InfluencerComponent.prototype.cancelCreateGroup = function () {
        this.showCreateNewGroupFragment = false;
        this.isEnableAddToGroup = true;
    };
    InfluencerComponent.prototype.afterCreateGroupSuccess = function (persistedGroup) {
        var _this = this;
        this.showCreateNewGroupFragment = false;
        this.isEnableAddToGroup = true;
        var companyId = this.userService.getCompanyId();
        // load list influencer group
        this.influencerGroupService.getInfluencerGroupShortList(companyId).subscribe(function (res) {
            _this.influencerGroupList = res.map(function (group) { return ({
                id: group.id,
                name: group.name,
                description: group.description
            }); });
            // Find the new group and add the selected influencers to new group
            var newGroup = res.find(function (group) { return group.name === persistedGroup.data.name; });
            if (newGroup && _this.addInfluencerToGroup) {
                _this.addInfluencerToGroup.influencerGroup.influencer_group_id = newGroup.id;
                _this.addInfluencerToGroup.influencerGroup.influencerGroupName = newGroup.name;
                _this.addInfluencerToGroup.influencerGroup.description = newGroup.description;
            }
        });
    };
    InfluencerComponent.prototype.onSelectedInfluencerCampaignChanged = function (e) {
        this.selectedInfluencerCampaign = new InfluencerCampaignActivity();
        this.selectedInfluencerCampaign.id = e.campaignId;
        this.selectedInfluencerCampaign.name = e.name;
        this.selectedInfluencerCampaign.campaignInfluencerId = e.campaignInfluencerId;
        this.isArchivedCampaign = e.campaignType === CampaignInfluencerStatus.ARCHIVED;
    };
    InfluencerComponent.prototype.removeFromCampaignConfirmation = function () {
        this.modalService.openInCenter(this.confirmRemoveFromCampaign);
    };
    InfluencerComponent.prototype.removeFromCampaign = function () {
        var _this = this;
        var campaignInfluencerId = this.selectedInfluencerCampaign.campaignInfluencerId;
        this.campaignService.deleteInfluencerFromCampaign(campaignInfluencerId).subscribe(function (res) {
            _this.influencerCampaignActivity.clearCachedData(campaignInfluencerId);
            _this.influencerCampaignActivity.clearSelectionAndReset();
            _this.clearCachedCampaignInfluencersData(_this.selectedInfluencerCampaign.id);
            _this.hideAlertSuccess();
            _this.eventTracker.trackUserAction(UserActionType.ACTION, Page.CAMPAIGN, {
                id: _this.selectedInfluencerCampaign.id,
                name: _this.selectedInfluencerCampaign.name,
                type: TargetType.CAMPAIGN
            }, {
                action: UserActionType.UPDATE,
                actionDetails: ActionDetails.REMOVED_INFLUENCERS,
                source: ActionSource.BOTTOM_BAR,
                influencers: [_this.influencerId]
            }, undefined, _this.activePage);
            _this.userService.triggerUpdateActivatedInfluencers();
        });
    };
    InfluencerComponent.prototype.openCampaignInReports = function () {
        this.router.navigate(['/measure/'], { queryParams: { campaign_id: this.selectedInfluencerCampaign.id } });
    };
    InfluencerComponent.prototype.goToCampaignOverview = function () {
        this.router.navigate(['/campaigns/' + this.selectedInfluencerCampaign.id]);
    };
    InfluencerComponent.prototype.exportPdfReport = function (popper) {
        if (this.influencerService.isCreditAvailable() === false) {
            var errorMsg = this.translateService.instant('INFLUENCER.insight.fallback_msg', {
                maxCredit: this.userService.maxActiveInfluencers
            });
            this.userService.doInvalidActionByLevel('Branded Exports', errorMsg);
        }
        if (this.influencerService.isCreditAvailable() === true && popper) {
            popper.hide();
            this.downloadPDF();
        }
    };
    InfluencerComponent.prototype.downloadPDF = function () {
        var _this = this;
        // cancel previous request
        if (this.exportPdfSubcription) {
            this.exportPdfSubcription.unsubscribe();
        }
        this.modalService.open(this.alertPdfDownloadPending, null, true, CommonConstant.PDF_EXPORT_NOTIFICATION_SHOWING_TIME);
        this.exportPdfSubcription = this.pdfViewerService.generateInfluencerDetailPdf(this.influencerId, this.demographicChannelParam, this.userService.getCompanyId(), this.channelFollowerParam, this.insightChannelParam)
            .subscribe({
            next: function () { _this.userService.triggerUpdateActivatedInfluencers(); },
            error: function (error) { return _this.handleExportError(error); }
        });
        this.sendMixpanelEvent();
    };
    InfluencerComponent.prototype.handleExportError = function (error) {
        if (error && error instanceof HttpErrorResponse) {
            var innerErrorData = error.error && error.error.data;
            if (innerErrorData === 'invalid_account_level') {
                this.closeModalPopup();
                this.notifyPdfExportErrorMessage = error.error.message;
                this.modalService.open(this.notifyPdfExportError, null, true);
            }
        }
    };
    InfluencerComponent.prototype.sendMixpanelEvent = function () {
        this.eventTracker.trackUserAction(UserActionType.ACTION, Page.INFLUENCER, {
            id: this.influencerId,
            name: this.influencerName,
            type: TargetType.INFLUENCER
        }, {
            action: UserActionType.EXPORT
        }, undefined, null, null);
    };
    Object.defineProperty(InfluencerComponent.prototype, "influencerName", {
        get: function () {
            return this.influencer ? this.influencer.name : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerComponent.prototype, "platformBackground", {
        get: function () {
            return this.userService.platformBackground;
        },
        enumerable: true,
        configurable: true
    });
    InfluencerComponent.prototype.getActivePageType = function (activeTabIndex) {
        switch (activeTabIndex) {
            case InfluencerTab.OVERVIEW: {
                return ActivePages.INFLUENCER_OVERVIEW;
            }
            case InfluencerTab.INSIGHT: {
                return ActivePages.INFLUENCER_INSIGHTS;
            }
            case InfluencerTab.DEMOGRAPHIC: {
                return ActivePages.INFLUENCER_DEMOGRAPHICS;
            }
            case InfluencerTab.CAMPAIGN: {
                return ActivePages.INFLUENCER_CAMPAIGNS;
            }
            default:
                return ActivePages.INFLUENCER_OVERVIEW;
        }
    };
    Object.defineProperty(InfluencerComponent.prototype, "activePage", {
        get: function () {
            return {
                type: this.getActivePageType(this.activeTabIndex),
                name: this.influencer.name,
                id: this.influencer.id,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerComponent.prototype, "campaignActionData", {
        /**
         * Defined data will be sent to Segment when free user click on Campaign Tab
         * @returns {{action: UserActionType; item: Page; target: {id: number; name: string; type: TargetType}}}
         */
        get: function () {
            if (!this.influencer) {
                return null;
            }
            return {
                action: UserActionType.VIEW,
                item: Page.INFLUENCER_CAMPAIGNS,
                target: {
                    id: this.influencer.id,
                    name: this.influencer.name,
                    type: TargetType.INFLUENCER
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerComponent.prototype, "isActiveOverviewTab", {
        get: function () {
            return this.activeTabIndex === InfluencerTab.OVERVIEW;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerComponent.prototype, "isActiveInsightTab", {
        get: function () {
            return this.activeTabIndex === InfluencerTab.INSIGHT;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerComponent.prototype, "isActiveDemographicTab", {
        get: function () {
            return this.activeTabIndex === InfluencerTab.DEMOGRAPHIC;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerComponent.prototype, "isActiveActivityTab", {
        get: function () {
            return this.activeTabIndex === InfluencerTab.ACTIVITY;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerComponent.prototype, "isActiveCampaignTab", {
        get: function () {
            return this.activeTabIndex === InfluencerTab.CAMPAIGN;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerComponent.prototype, "isDisableActivityTab", {
        get: function () {
            return this.userService.isFreeUser() || AppSettings.isDisableChat();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerComponent.prototype, "hasSelectedPostToDelete", {
        get: function () {
            return Array.isArray(this.postToDelete) && this.postToDelete.length > 0 && this.campaignNeedToDeletePost;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Defined data will be sent to Segment when free user click on 'Add Grouo' or 'Add to Campaign' button
     * @returns {{action: UserActionType; item: Page; target: {id: number; name: string; type: TargetType}}}
     */
    InfluencerComponent.prototype.invalidActionData = function (forGroup) {
        if (!this.influencer) {
            return null;
        }
        return {
            action: UserActionType.ACTION,
            item: forGroup ? Page.GROUP : Page.CAMPAIGN,
            target: {
                id: this.influencer.id,
                name: this.influencer.name,
                type: forGroup ? TargetType.INFLUENCER_GROUP : TargetType.CAMPAIGN
            },
            params: {
                action: UserActionType.UPDATE,
                source: ActionSource.BOTTOM_BAR,
                actionDetails: ActionDetails.ADDED_INFLUENCERS,
            },
            activePage: this.activePage
        };
    };
    InfluencerComponent.prototype.closeModalPopup = function () {
        this.modalService.close();
    };
    InfluencerComponent.prototype.contactSupport = function () {
        this.userService.contactSupport();
    };
    InfluencerComponent.prototype.onSelectPostToDelete = function (campaignPostDelete) {
        this.postToDelete = campaignPostDelete.posts;
        this.campaignNeedToDeletePost = campaignPostDelete.campaignId;
    };
    InfluencerComponent.prototype.confirmBeforeDeleteingPost = function () {
        this.modalService.openInCenter(this.confirmDeletePostFromCampaign, null);
    };
    InfluencerComponent.prototype.onDeletePostFromCampaign = function () {
        var _this = this;
        this.closeModalPopup();
        this.campaignService.deletePostFromCampaign(this.campaignNeedToDeletePost, this.postToDelete).subscribe(function (res) {
            var deletedPostUrlHashs = _this.postToDelete.map(function (p) { return p.urlHash; });
            _this.campaignNeedToDeletePost = null;
            _this.postToDelete = null;
            _this.modalService.open(_this.notifyPostDeletedSuccess, null, true);
            if (_this.influencerCampaignActivity) {
                _this.influencerCampaignActivity.campaignPosts = _this.influencerCampaignActivity.campaignPosts
                    .filter(function (cp) { return deletedPostUrlHashs.indexOf(cp.urlHash) < 0; });
                _this.influencerCampaignActivity.clearCachedData(_this.campaignInfluencerId);
            }
            _this.clearCachedCampaignInfluencersData(_this.selectedInfluencerCampaign.id);
        }, function (error) {
            _this.modalService.open(_this.notifyPostDeletedError, null, true);
        });
    };
    InfluencerComponent.prototype.getCachingKeys = function (companyId, influencerId, campaignInfluencerId) {
        var cachedKeys = [
            "group_list_" + companyId,
            "campaign_list_" + companyId,
            "influencer_" + influencerId,
            "influencer_top_exposures_" + influencerId,
            "influencer_daily_kpis_" + influencerId,
            "influencer_posts_" + influencerId,
            "influencer_best_performing_" + influencerId,
            "influencer_audience_data_" + influencerId
        ];
        if (campaignInfluencerId) {
            cachedKeys.push("campaign_influencer_" + campaignInfluencerId);
            cachedKeys.push("campaign_influencer_details_" + campaignInfluencerId);
            cachedKeys.push("campaign_influencer_list_" + campaignInfluencerId);
        }
        return cachedKeys;
    };
    InfluencerComponent.prototype.clearCachedCampaignInfluencersData = function (campaignId) {
        this.cacheService.clear("campaign_influencers_" + campaignId);
        this.cacheService.clear("campaign_details_influencers_" + campaignId);
    };
    return InfluencerComponent;
}(AbstractAchooComponent));
export { InfluencerComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer.component.ts.pre-build-optimizer.js